import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/SiteHeader.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/AffiliateLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AffiliateProductCards"] */ "/vercel/path0/components/AffiliateProductCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrackedLink"] */ "/vercel/path0/components/analytics/TrackedLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ArticleViewTracker"] */ "/vercel/path0/components/ArticleViewTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CvDownloadForm"] */ "/vercel/path0/components/CvDownloadForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlakatDownloadForm"] */ "/vercel/path0/components/PlakatDownloadForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MagnetCapture"] */ "/vercel/path0/components/shared/MagnetCapture.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareBar"] */ "/vercel/path0/components/shared/ShareBar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
